import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "children"];
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { Type } from '../Type/Type';
var levelSizeMap = {
  large: 3,
  medium: 2,
  small: 1
};

/**
 * Body abstraction over Type. We spread the constrained Body
 * props last and explicitly set others to undefined to prevent them from
 * being overridden.
 *
 * For example, all Body text should be gotham and have normal weight.
 *
 * @deprecated
 */
export var Body = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedComponentWarning({
    component: 'Body',
    migration: 'Use <Text>.'
  });
  return /*#__PURE__*/React.createElement(Type, _extends({}, otherProps, {
    color: undefined,
    "data-currency": "Body",
    fontFamily: "gotham",
    uppercase: undefined,
    size: levelSizeMap[size],
    ref: ref
  }), children);
});
Body.displayName = 'Body';